import "./CustomFooter.css";
import pkg from "../../../package.json";

export const CustomFooter = () => {
    return (
        <div id="study-page-footer" className="study-page-footer">
            <p id="p-customFooter-a">
                © {new Date().getFullYear()} LCCV&nbsp;&nbsp;WebApp {pkg.version}
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Octopus 22.0.0, Processor 1.2.12.1,
                combiRAOPreprocessor 1.1, GridSnap 1.2.0, Optimizer 4.3.5, Optimization Solver
                13.0.2
            </p>

            <p id="p-customFooter-b">
                <a
                    id="a-customFooter-a"
                    href="https://www.tscnet.eu/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    TSCNET Services GmbH
                </a>
            </p>
        </div>
    );
};
